import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './pages/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home/index';
import News from './pages/News/index';
import NewsDetail from './pages/NewsDetail/index';
import PublicReport from './pages/PublicReport/index';
import AboutUs from './pages/AboutUs/index';
import Projects from './pages/Project/index';
import ProjectDetail from './pages/ProjectDetail/index';
import ApplyInfo from './pages/ApplyInfo/index';
import PrivacyPolicy from './pages/PrivacyPolicy/index';
import TermsOfService from './pages/TermsOfService/index';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/public-report" element={<PublicReport />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/apply-info" element={<ApplyInfo />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
